<div class="container main-container d-flex justify-content-center align-items-center mh-70">
  <app-loading-spinner></app-loading-spinner>
</div>
